export default __webpack_public_path__ + "static/media/pending-status.3bf5690d.svg";